<template>
  <div>
    <child/>
  </div>
</template>

<script>
export default {
  name: 'BasicLayout'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// resources/js/layouts/basic.vue